import { render, staticRenderFns } from "./IncidentCombobox.vue?vue&type=template&id=86067270&"
import script from "./IncidentCombobox.vue?vue&type=script&lang=ts&"
export * from "./IncidentCombobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports